import React from "react";
const autobind = require("class-autobind").default;
import { FormGroup } from "../../form/group/index";
import { Input } from "../../form/input/index";
import { InputBox } from "../../form/input.box/index";
import { Button } from "../../button/index";
import { FaTrashAlt, FaCopy } from "react-icons/fa";
import shortid from "shortid";
import { applyTableTemplate, clearTableTemplateOverride, DEFAULT_MAIN_FLOOR_ID, ensureFloorPlans, resolveTableTemplateId, TABLE_TEMPLATES, } from "@lib/common";
export { FLOOR_TABLE_DISPLAY_PX, TableTemplateGraphic, TABLE_TEMPLATE_IMAGE_SRC, } from "./table-template-graphic";
export class FieldDineInTables extends React.Component {
    constructor(props) {
        super(props);
        autobind(this);
    }
    copy(i) {
        const values = [...this.props.values];
        const value = { ...values[i] };
        value._id = shortid.generate();
        values.push(value);
        this.props.onChange(values);
    }
    remove(i) {
        const values = [...this.props.values];
        values.splice(i, 1);
        this.props.onChange(values);
    }
    change(i, key, value) {
        const values = [...this.props.values];
        values[i][key] = value;
        this.props.onChange(values);
    }
    changeTemplate(i, templateId) {
        const values = [...this.props.values];
        if (!templateId) {
            values[i] = clearTableTemplateOverride(values[i]);
        }
        else {
            values[i] = applyTableTemplate(values[i], templateId);
        }
        this.props.onChange(values);
    }
    changeSeats(i, raw) {
        const parsed = parseInt(raw, 10);
        const seats = Number.isFinite(parsed) && parsed > 0 ? parsed : undefined;
        this.change(i, "seats", seats);
    }
    areaOptions = () => Array.from(new Set(this.props.values
        .map((t) => (t.area || "").trim())
        .filter(Boolean))).sort();
    render() {
        const { values, baseURL, reservationsV2Enabled = false } = this.props;
        const floors = ensureFloorPlans(this.props.floorPlans);
        const areas = reservationsV2Enabled ? this.areaOptions() : [];
        const areaListId = "dine-in-table-areas";
        return (React.createElement("div", null,
            reservationsV2Enabled && (React.createElement("datalist", { id: areaListId }, areas.map((area) => (React.createElement("option", { key: area, value: area }))))),
            values.map((item, i) => {
                let url = "";
                if (item.name && item.password) {
                    url =
                        baseURL +
                            `?table_id=${item._id}&table_pw=${item.password}`;
                }
                else if (item.name) {
                    url = baseURL + `?table_id=${item._id}`;
                }
                const templateId = resolveTableTemplateId(item);
                const templateSelectValue = item.table_template_id || "";
                return (React.createElement("div", { key: i, className: "flex-line", style: { alignItems: "flex-end" } },
                    React.createElement(InputBox, { className: "no-round width64 width42 text-center" },
                        React.createElement("p", { className: "big font-bold", style: { lineHeight: "36px" } }, i + 1)),
                    React.createElement("div", { className: "flex-line", style: { alignItems: "flex-end" } },
                        React.createElement(FormGroup, { className: "m-b-0", title: i === 0 ? "Table Name" : null, small_title: true, no_border: true },
                            React.createElement(Input, { type: "text", className: "no-round", style: { width: "130px" }, value: item.name, onChange: (e) => this.change(i, "name", e.target.value) })),
                        React.createElement(FormGroup, { className: "m-b-0", title: i === 0 ? "Table Password" : null, small_title: true, no_border: true },
                            React.createElement(Input, { type: "text", className: "no-round", style: { width: "120px" }, value: item.password, onChange: (e) => this.change(i, "password", e.target.value) })),
                        reservationsV2Enabled && (React.createElement(FormGroup, { className: "m-b-0", title: i === 0 ? "Area / Location" : null, small_title: true, no_border: true },
                            React.createElement(Input, { type: "text", className: "no-round", style: { width: "130px" }, value: item.area || "", list: areaListId, placeholder: "e.g. Patio", onChange: (e) => this.change(i, "area", e.target.value) }))),
                        reservationsV2Enabled && (React.createElement(FormGroup, { className: "m-b-0", title: i === 0 ? "Seats" : null, small_title: true, no_border: true },
                            React.createElement(Input, { type: "number", min: 1, step: 1, className: "no-round", style: { width: "72px" }, value: item.seats && item.seats > 0
                                    ? item.seats
                                    : "", placeholder: "4", onChange: (e) => this.changeSeats(i, e.target.value) }))),
                        reservationsV2Enabled && (React.createElement(FormGroup, { className: "m-b-0", title: i === 0 ? "Table Type (optional)" : null, small_title: true, no_border: true },
                            React.createElement("div", { style: {
                                    display: "flex",
                                    alignItems: "center",
                                    gap: "6px",
                                } },
                                React.createElement("select", { className: "no-round", style: {
                                        width: "170px",
                                        height: "36px",
                                    }, value: templateSelectValue, onChange: (e) => this.changeTemplate(i, e.target.value) },
                                    React.createElement("option", { value: "" }, "Auto (from seats)"),
                                    TABLE_TEMPLATES.map((opt) => (React.createElement("option", { key: opt.id, value: opt.id }, opt.label))))))),
                        reservationsV2Enabled && floors.length > 1 && (React.createElement(FormGroup, { className: "m-b-0", title: i === 0 ? "Floor" : null, small_title: true, no_border: true },
                            React.createElement("select", { className: "no-round", style: {
                                    width: "110px",
                                    height: "36px",
                                }, value: item.floor_plan_id ||
                                    DEFAULT_MAIN_FLOOR_ID, onChange: (e) => this.change(i, "floor_plan_id", e.target.value) }, floors.map((f) => (React.createElement("option", { key: f._id, value: f._id }, f.name)))))),
                        React.createElement(FormGroup, { className: "m-b-0", title: i === 0 ? "Order URL" : null, small_title: true, no_border: true },
                            React.createElement(Input, { type: "text", className: "no-round", style: { width: "150px" }, value: url, readOnly: true, onFocus: (e) => e.target.select() }))),
                    React.createElement(Button, { type: "button", className: "no-round", paddinglr: 5, color: "white", onClick: () => this.remove(i) },
                        React.createElement(FaTrashAlt, null)),
                    React.createElement(Button, { type: "button", className: "no-round", paddinglr: 5, color: "white", onClick: () => this.copy(i) },
                        React.createElement(FaCopy, null))));
            })));
    }
}
//# sourceMappingURL=index.js.map